import { errorsEnum, errorsTranslatePtBrEnum } from '@/enums/errorsEnum';

export default {
  'Date not found to index DOLAR-C!': 'Data não encontrada para o índice DOLAR-C!',
  'Date not found to index DOLAR-V!': 'Data não encontrada para o índice DOLAR-V!',
  'Date to UFIR must be between 01/01/1992 and 31/12/2000':
    'Data para o índice UFIR deve ser entre 01/01/1992 e 31/12/2000',
  'Date to URV must be between 01/04/1993 and 30/06/1994':
    'Data para o índice URV deve ser entre 01/04/1993 e 31/12/2000',
  'Date not found to index SALÁRIO-MÍNIMO!': 'Data não encontrada para o índice SALÁRIO-MÍNIMO!',
  'Date to BTN must be between 01/02/1989 and 28/02/1991':
    'Data para o índice BTN deve ser entre 01/02/1989 e 28/02/1991',
  'Date to ORTN must be between 01/08/1964 and 28/02/1986':
    'Data para o índice ORTN deve ser entre 01/08/1964 e 28/02/1986',
  'Date to OTN must be between 01/03/1986 and 28/02/1989':
    'Data para o índice OTN deve ser entre 01/03/1986 e 28/02/1989',
  'Date not found to index TJRJ!': 'Data não encontrada para o índice TJRJ!',
  'Date not found to index PISO-SALARIAL!': 'Data não encontrada para o índice PISO-SALARIAL!',
  'Date not found to index FCA!': 'Data não encontrada para o índice FCA!',
  'Date not found to index UFM!': 'Data não encontrada para o índice UFM!',
  'Date not found to index MÉDIA INPC/IGP-DI!': 'Data não encontrada para o índice DOLAR-V!',
  'Date not found to index DOLAR COMPRA - Comercial!': 'Data não encontrada para o índice DOLAR COMPRA - Comercial!',
  'Date not found to index DOLAR VENDA - Comercial!': 'Data não encontrada para o índice DOLAR VENDA - Comercial!',
  'Date not found to index URV - Diária!': 'Data não encontrada para o índice URV - Diária!',
};
